// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"406":"3ab6612b","508":"3071c8f8"}[chunkId] + ".chunk.css";
};